const { default: flatpickr } = require("flatpickr");

window.setup_flatpickr = function() {
  $('.flatpickr').toArray().forEach(function(field){
    flatpickr(field, {
      dateFormat: "m/d/Y"
    })
  });
}